export default class Blacklist {
    constructor() {
        this.gameId = 6;
        this.baseUrl = "https://gamification.jdsoftwarellc.com/";
    }
    async Check() {
        let data = await this.GetBlacklist();
        let blacklist = data || [];

        let localUrl = window.location.href || "";
        //check if local url is in blacklist
        let isBlacklisted = blacklist.some(function (url) {
            if (!localUrl) return false;
            if (!url) return false;
            //check if url is in blacklist
            let re = new RegExp(url, 'gi');
            return localUrl.match(re);
        });

        return isBlacklisted;
    }
    async GetBlacklist(gameId) {
        if (!gameId && gameId != 0) gameId = this.gameId;

        var url = `api/Blacklist/${gameId}`;
        url = this.baseUrl + url;

        let data = await this.MakeRequest("GET", url);
        return JSON.parse(data);
    };
    MakeRequest(method, url, data, ContentType) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.setRequestHeader("cache-control", "private");
            if (ContentType) xhr.setRequestHeader("Content-type", ContentType);
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    // var returnData = JSON.parse(xhr.responseText);
                    resolve(xhr.responseText);
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    url: url,
                    status: this.status,
                    statusText: xhr.statusText
                });
            };
            if (!data)
                xhr.send();
            else
                xhr.send(data);
        });
    };
}
